import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {
  StyledEditInvoiceModal,
  StyledEditInvoiceModalSpace,
  StyledEditInvoiceModalLogoContainer,
} from './StyledEditInvoiceModal';
import {EditLineIcon} from '../../../../icons';

const EditInvoiceModal = ({
  open,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'invoices']);

  const trans = (key, options) => t(`invoices:modal.edit.${key}`, options);

  return (
    <StyledEditInvoiceModal
      open={open}
      okText={t('edit')}
      cancelButtonProps={{size: 'large'}}
      okButtonProps={{size: 'large', type: 'primary'}}
      width={400}
      title={trans('title')}
      {...rest}
    >
      <StyledEditInvoiceModalSpace
        align='center'
        direction='vertical'
        size={10}
      >
        <StyledEditInvoiceModalLogoContainer>
          <EditLineIcon />
        </StyledEditInvoiceModalLogoContainer>
        <p>{trans('description')}</p>
      </StyledEditInvoiceModalSpace>
    </StyledEditInvoiceModal>
  );
}

EditInvoiceModal.propTypes = {
  open: PropTypes.bool.isRequired,
}

export default EditInvoiceModal;
